import React, { useEffect, useState } from 'react';
import Styles from './BenefitWrapper.module.scss';
import RichText from '../richtext';
import { Form } from 'react-bootstrap';
import StaticLineTable from '../StaticLineTable';
import Cookies from 'js-cookie';

const BenefitWrapper = ({
  content,
  metadata,
  setGenericErrorModalDetails,
  loginSuccess,
  basicConfigUrl,
  setLoginSuccess,
  isProdEnv,
}: any) => {
  const [selectedOption, setSelectedOption] = useState<string>('default');
  const [selectedExistingOption, setSelectedExistingOption] = useState([]);
  const [toggleOn, setToggleOn] = useState<boolean>(false);
  const [toggleOff, setToggleOff] = useState<boolean>(false);
  const [newtoggleswitchs, setNewtoggleswitchs] = useState<boolean>(false);
  const [eixstingtoggle, seteixstingtoggle] = useState<boolean>(false);
  const newKeyName = content?.benefitSelection?.[0]?.benefits?.[0]?.key;
  const existingKeyName = content?.benefitSelection?.[0]?.benefits?.[1]?.key;

  const handleNewToggle = (e: any) => {
    setNewtoggleswitchs(!newtoggleswitchs);
    if (newKeyName && e?.target?.checked) {
      setSelectedOption(newKeyName);
    } else if (existingKeyName && eixstingtoggle) {
      setSelectedOption(existingKeyName);
    } else {
      setSelectedOption('default');
    }
  };
  const handleExistingToggle = (e: any) => {
    seteixstingtoggle(!eixstingtoggle);
    if (existingKeyName && e?.target?.checked) {
      setSelectedOption(existingKeyName);
    } else if (newKeyName && newtoggleswitchs) {
      setSelectedOption(newKeyName);
    } else {
      setSelectedOption('default');
    }
  };

  const toggles = (e: any, key: any) => {
    const selectedOption: any = [...selectedExistingOption];
    const checked = e.target.checked;
    if (!selectedOption.includes(key) && checked) {
      selectedOption.push(key);
    } else if (!checked) {
      const index = selectedOption.indexOf(key);
      if (index > -1) {
        selectedOption.splice(index, 1);
      }
    }
    setSelectedExistingOption(selectedOption);
    if (key === 'Mobile') {
      setToggleOn(!toggleOn);
    } else {
      setToggleOff(!toggleOff);
    }
  };

  let authData: any = typeof window !== undefined && Cookies.get('sunriseAuth');
  authData = authData && JSON.parse(authData);
  useEffect(() => {
    if (authData != undefined) {
      setSelectedOption('default');
      setSelectedExistingOption([]);
    }
  }, []);

  return (
    <>
      {authData == undefined && (
        <div className={Styles.container}>
          <div className={Styles.title}>
            <RichText content={content?.benefitSelection?.[0]?.title} />
          </div>
          <div className={Styles.wrapper}>
            <div className={Styles.showselect}>
              {!eixstingtoggle && (
                <div className={`${Styles.itemStyles} ${Styles.newCustomer}`}>
                  <div className={Styles.options}>
                    {content?.benefitSelection?.[0]?.benefits?.[0]?.options?.[0].title}
                  </div>
                  <div className={Styles.toggle}>
                    <Form>
                      <Form.Check
                        type='switch'
                        readOnly={true}
                        checked={newtoggleswitchs}
                        onClick={(e) => handleNewToggle(e)}
                      />
                    </Form>
                  </div>
                </div>
              )}
              <div className={`${Styles.itemStyles} ${Styles.existingCustomer}`}>
                <div className={Styles.options}>
                  {content?.benefitSelection?.[0]?.benefits?.[1]?.title}
                </div>
                <div className={Styles.toggle}>
                  <Form>
                    <Form.Check
                      type='switch'
                      readOnly={true}
                      checked={eixstingtoggle}
                      onClick={(e) => handleExistingToggle(e)}
                    />
                  </Form>
                </div>
              </div>
              {eixstingtoggle &&
                content?.benefitSelection?.[0]?.benefits?.[1]?.options?.map(
                  (benefits: any, index: number) => (
                    <>
                      <div className={`${Styles.itemStyles} ${Styles.existingWrapper}`} key={index}>
                        <div className={Styles.options}>{benefits?.title}</div>
                        <div className={Styles.toggle}>
                          <Form>
                            <Form.Check
                              type='switch'
                              readOnly={true}
                              checked={benefits?.key === 'Mobile' ? toggleOn : toggleOff}
                              onClick={(e) => toggles(e, benefits?.key)}
                            />
                          </Form>
                        </div>
                      </div>
                    </>
                  )
                )}
            </div>
          </div>
        </div>
      )}
      {selectedOption && selectedOption == 'new-customer' ? (
        <StaticLineTable
          content={content?.youngProducts?.[0]}
          metadata={metadata}
          setGenericErrorModalDetails={setGenericErrorModalDetails}
          loginSuccess={loginSuccess}
          selectedOption={selectedOption}
          basicConfigUrl={basicConfigUrl}
          selectedExistingOption={selectedExistingOption}
          setLoginSuccess={setLoginSuccess}
          isProdEnv={isProdEnv}
        />
      ) : (
        <StaticLineTable
          content={content?.upMobileProducts?.[0]}
          metadata={metadata}
          setGenericErrorModalDetails={setGenericErrorModalDetails}
          loginSuccess={loginSuccess}
          selectedOption={selectedOption}
          basicConfigUrl={basicConfigUrl}
          selectedExistingOption={selectedExistingOption}
          setLoginSuccess={setLoginSuccess}
          isProdEnv={isProdEnv}
        />
      )}
    </>
  );
};
export default BenefitWrapper;
